<template>
  <div class="boxbgcolor ioRecord">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              v-model="search.plateNumber"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <!-- <div class="form-group">
            <label for>卡类型:</label>
            <el-select v-model="search.plateType" clearable placeholder="请选择">
              <el-option
                v-for="item in allPlateTypes"
                :key="item.value"
                :label="item.labelDefault"
                :value="item.value"
              ></el-option>
            </el-select>
          </div> -->
          <div class="form-group">
            <label for>出场时间:</label>
            <bosk-shortcut-datetime
              v-on:current-datetime-change="onCurrentDatetimeChange"
            ></bosk-shortcut-datetime>
            <!-- <el-date-picker
              v-model="search.outTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker> -->
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="primary"
                :loading="loading"
                 size="small"
              >
                查询
              </el-button>
            </span>

            <el-button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="downloadLoading"
            >
              导出EXCEL
            </el-button>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <!-- <span class="download_btn">
							<JsonExcel
							class = "btn"
							:fetch= "downloadData"
							:fields= "download_fields"
							type= "xls"
							name = "进出记录.xls">
							下载EXCEL
							</JsonExcel>
            </span>-->
            <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          @header-dragend="colChange"
          show-summary
          :summary-method="getSummaries"
          v-loading="loading"
        >
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingId"
          >
            <template slot-scope="scope">{{
              scope.row.parkingId
                ? JSON.parse(scope.row.parkingId).parkingName
                : ""
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌号码"
            prop="plateNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="是否出场"
            prop="position"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="放行类型"
            prop="matchingMethod"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="进场通道"
            prop="channelInId"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.channelInId
                  ? JSON.parse(scope.row.channelInId).name
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="出场通道"
            prop="channelId"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.channelId ? JSON.parse(scope.row.channelId).name : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="进场时间"
            prop="beginDate"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="出场时间"
            prop="endDate"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="订单编号"
            prop="orderNum"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="支付金额"
            prop="realMoney"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  indoorIoRecordList,
  indoorAllCarType,
  indoorAllPlateType,
  indoorAllOpenMethod,
} from "@/api/url";

import Page from "../../commons/page.vue";

import AreaTree from "../../commons/parking/commons/areaTree.vue";

import JsonExcel from "vue-json-excel";

import Refresh from "../../commons/parking/commons/refresh.vue";

import BoskShortcutDatetime from "../../commons/BoskShortcutDatetime/BoskShortcutDatetime.vue";

export default {
  name: "io-record-list",
  data() {
    return {
      value1: "",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        parkingId: "",
        areaId: "",
      },
      download_fields: {},
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        outTime: [],
        plateType: '',
        plateNumber: '',
      },
      tableListData: {
        rows: [],
      },
      allCarTypes: null,
      allPlateTypes: null,
      allOpenMethods: null,
      defaultProps: {
        children: "children",
        label: "label",
      },

      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
      pageObj: {},
      totalMap:{},
      loading: false,
      downloadLoading: false
    };
  },
  components: {
    Page,
    AreaTree,
    Refresh,
    JsonExcel,
    BoskShortcutDatetime,
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },

  mounted: function() {
    // this.tableList(this.search.pageNumber);
    this.getAllCarType();
    this.getAllPlateType();
    this.getAllOpenMethod();
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.search.plateNumber = "";
      // this.search.outTime = [];
      this.search.carType = "";
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.parkingId = "";
        this.tableListData.rows = [];
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择停车场'
        // })
        return;
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      this.$get(indoorIoRecordList(), {
        plateNumber: this.search.plateNumber,
        parkingId: this.treeData.parkingId,
        plateType: this.search.plateType,
        beginTime: this.search.outTime ? this.search.outTime?.[0] ?? "" : "",
        endTime: this.search.outTime ? this.search.outTime?.[1] ?? "" : "",
        limit: this.search.pageSize,
        page: curPage,
        position: 1,
      }).then((data) => {
        if (data.status != 200) return;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj = { ...pageObj };
        _this.tableListData.rows = data.data.rows;
        this.totalMap=data.data.totalMap;
      }).finally(() => {
        this.loading = false;
      });
    },
    getAllCarType() {
      this.$get(indoorAllCarType()).then((data) => {
        if (data.status != 200) return;
        this.allCarTypes = data.data.rows;
      });
    },
    getAllPlateType() {
      this.$get(indoorAllPlateType()).then((data) => {
        if (data.status != 200) return;
        this.allPlateTypes = data.data.rows;
      });
    },
    getAllOpenMethod() {
      this.$get(indoorAllOpenMethod()).then((data) => {
        if (data.status != 200) return;
        this.allOpenMethods = data.data.rows;
      });
    },
    searchList: function() {
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    // async downloadData() {
    //   const response = await this.$get(indoorIoRecordList(), {
    //     plateNumber: this.search.plateNumber,
    //     orderNum: this.search.orderNum,
    //     parkingId: this.treeData.parkingId
    //   });
    //   return response.data.rows;
    // },

    downloadData() {
     
      const { plateNumber, plateType, outTime, position } = this.search;
      const { parkingId } = this.treeData;
      const [beginTime, endTime] = outTime ?? [];
      if (!parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.downloadLoading=true;
      this.$downloadFileRequest(
        "/api/onsite/parkingRecord/parkingRecordExport",
        {
          beginTime,
          endTime,
          parkingId,
          plateType,
          plateNumber,
          position,
        },
        "车场进出记录"
      ).finally(()=>{
        this.downloadLoading=false;
      });
    },
    onCurrentDatetimeChange(v) {
      this.search.outTime = [...v];
    },
    colChange() {},
    getSummaries(param) {
    
    const { columns, data } = param;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = "总计";
      }
      if (index === 9) {
        sums[index] = this.totalMap?.totalRealMoney ?? 0;
      }
   
    });
    return sums;
  },
  },
};
</script>

<style scoped>
.boxbgcolor {
  /*margin-top:20px;*/
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.demo-table-expand {
  font-size: 0;
}
.detail {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.detail ul {
  width: 50%;
}
.detail ul li {
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail ul li span {
  display: inline-block;
  width: 50%;
}
.detail ul li span:first-child {
  text-align: right;
  color: #aaa;
  font-weight: bold;
  width: 100px;
}
.detail ul li span:last-child {
  text-align: left;
  padding: 0 0 0 20px;
}
.list-yes-tree {
  /* height:calc(100% - 100px); */
  overflow: auto;
}
.ioRecord .list-right{
  height:calc(100vh - 220px)
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
</style>
